import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Img from "gatsby-image";
import Theme from "../../../vars/ThemeOptions";
import RichText from "../../../richText/RichText";
import { H3, P } from "../../common";
import get from "lodash/get";
import FigureCaption from "react-bootstrap/esm/FigureCaption";
const Styled = {};
Styled.Snapshot = styled.div`
  width: 100%;
  position: relative;
`;

Styled.SnapshotImage = styled.figure`
  position: absolute;
  z-index: 0;
  top: 0;
  left: ${({ title }) => (title === "Commit to Sit" ? "40%" : 0)};
  @media screen and (max-width: ${Theme.break.sm}px) {
    left: 0;
  }
  width: 55%;
  height: 50vw;
  max-height: 40rem;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 991px) {
    width: 95%;
    height: 75vw;
    position: relative;
  }
`;

Styled.SnapshotCopy = styled.div`
  position: absolute;
  z-index: 1;
  top: 75px;
  right: ${({ title }) => (title === "Commit to Sit" ? "initial" : "5%")};
  width: 45%;
  padding: 30px 45px;
  background: ${Theme.hex("offWhite")};

  @media only screen and (max-width: 991px) {
    position: relative;
    width: 100%;
    right: 0;
    bottom: 16vh;
    top: initial;
    margin-bottom: -16vh;
  }
`;
Styled.Caption = styled(FigureCaption)`
  text-align: center;
  max-width: 70%;
  margin: 0 auto 0 10%;
  background: ${Theme.alpha("blue", 0.85)};
  color: ${Theme.hex("white")};
  position: absolute;
  bottom: .5rem;
  width: 100%;
  padding: 1rem;
`;

export const Snapshot = ({ module }) => {
  const [copyHeight, setCopyHeight] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const [wrapHeight, setWrapHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const copyRef = useRef();
  const imageRef = useRef();
  useEffect(() => {
    const handleResize = () => {
      const winWidth = window.innerWidth;

      if (winWidth < 992) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
      setCopyHeight(copyRef.current.offsetHeight);
      setImageHeight(imageRef.current.offsetHeight);
      copyHeight > imageHeight
        ? setWrapHeight(copyHeight + 100)
        : setWrapHeight(imageHeight + 100);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [copyHeight, wrapHeight, imageHeight]);
  // console.log("copyHeight: ", copyHeight);
  // console.log("module: ", module)
  const { bodyCopy, snapImage, title } = module ? module : null;
  const { fluid } = snapImage ? snapImage : null;
  const { json } = bodyCopy ? bodyCopy : { json: null };
  const snapDesc = get(snapImage, `description`);
  return (
    <Styled.Snapshot style={isMobile ? undefined : { height: wrapHeight }}>
      <Styled.SnapshotImage ref={imageRef} title={title}>
        {fluid ? (
          <div style={{ position: "relative" }}>
            <Img fluid={fluid} alt={snapImage.title} />
            {snapDesc ? <Styled.Caption>{snapDesc}</Styled.Caption> : null}
          </div>
        ) : null}
      </Styled.SnapshotImage>
      <Styled.SnapshotCopy ref={copyRef} title={title}>
        <H3>{title}</H3>
        <P left>
          <RichText json={json} />
        </P>
        <SnapTab />
      </Styled.SnapshotCopy>
    </Styled.Snapshot>
  );
};

Styled.SnapTabTab = styled.div`
  position: absolute;
  z-index: 0;
  top: -30px;
  left: 30px;
  height: 30px;
  padding: 0 20px 0 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${Theme.hex("blue")};
  color: ${Theme.hex("white")};
  border-right: 5px solid ${Theme.hex("green")};
  p {
    margin-bottom: 0;
    font-weight: bold;
  }
`;
Styled.SnapTabCorner = styled.div`
  position: absolute;
  top: -30px;
  left: 0;
  height: 30px;
  width: 30px;
  background: ${Theme.hex("blue")};
  border-top-left-radius: 50%;
`;

const SnapTab = () => {
  return (
    <>
      <Styled.SnapTabTab className="snap-tab">
        <p>SNAPSHOT</p>
      </Styled.SnapTabTab>
      <Styled.SnapTabCorner className="snap-tab-corner" />
    </>
  );
};

Styled.SnapTitle = styled.h6``;
